import React from "react";
import { IconButton } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";

interface FavouriteStarProps {
    isFavourite: boolean;
    onClick: (isFavourite: boolean) => void;
    size?: "small" | "medium" | "large";
    disabled?: boolean;
}

const FavouriteIcon: React.FC<FavouriteStarProps> = ({
    isFavourite,
    onClick,
    size = "small",
    disabled = false,
}) => {
    return (
        <IconButton
            size={size}
            disabled={disabled}
            onClick={() => onClick(isFavourite)}
            sx={{ color: isFavourite ? "orange" : "inherit" }}
            aria-label={isFavourite ? "Remove from favourites" : "Add to favourites"}
        >
            {isFavourite
                ? <StarIcon sx={{ color: "orange" }} />
                : <StarOutlineIcon />
            }
        </IconButton>
    );
};

export default FavouriteIcon;
